import type { Invitation } from './invitationApi';

/**
 * Resolves an invitation's inviter to a display name. Returns the fallback
 * when both first/last name are missing or blank.
 */
export function resolveInviterName(invitation: Invitation, fallback: string): string {
  const firstName = invitation.inviter.firstName ?? '';
  const lastName = invitation.inviter.lastName ?? '';
  const composed = `${firstName} ${lastName}`.trim();
  if (composed.length > 0) return composed;
  return fallback;
}
